<template>
  <div class="broken-charger">

    <div class="row">
      <div class="col">
        <div class="card shadow">
          <div class="card-body">

            <div class="row">
              <div class="col-xl-3 col-lg-6">
                <b-form-group class="ct-mb-margin-bottom-100" label-class="col-form-label"
                              label="충전소" label-for="searchStation"
                              label-cols="3" content-cols="9" >
                  <multiselect id="searchStation"
                               v-model="selectedStation"
                               :options="stationOptions"
                               label="placeName" placeholder="" select-label=""
                               :allow-empty="false" deselect-label=""
                               :max-height="202" @input="search">
                    <span slot="noResult">No Result</span>
                  </multiselect>
                </b-form-group>
              </div>

              <div class="col-xl-3 col-lg-6">
                <b-form-group label-class="col-form-label"
                              label="조회 기간" label-for="searchBrokenDate"
                              label-cols="3" content-cols="9">
                  <date-picker id="searchBrokenDate" v-model="selectedDate"
                               range value-type="format" :disabled-date="disabledAfterYesterday" @input="search">
                    <template v-slot:footer="{ emit }">
                      <div class="text-start">
                        <b-button size="sm" variant="outline-primary me-1" @click="$_utils.periodOneMonth(emit, 'yesterday')">
                          1개월
                        </b-button>
                        <b-button size="sm" variant="outline-primary me-1" @click="$_utils.periodThreeMonth(emit, 'yesterday')">
                          3개월
                        </b-button>
                        <b-button size="sm" variant="outline-primary" @click="$_utils.periodSixMonth(emit, 'yesterday')">
                          6개월
                        </b-button>
                      </div>
                    </template>
                  </date-picker>
                </b-form-group>
              </div>

<!--              <search-buttons layout-class="col-xl-4 ct-margin-top-25"-->
<!--                              resetBtnClass="search-btn-reset" searchBtnClass="search-brokenbutton"-->
<!--                              :reset-fn="reset" :search-fn="search" />-->
            </div>

          </div>
        </div>
      </div>
    </div>


    <div class="row">
      <div class="col">
        <div class="card shadow">
          <div class="card-body pb-0">

            <div class="row">
              <div class="col-xl-5">
                <div class="card">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-11">
                        <card-title icon-image="mdi-battery-off-outline" title="고장 충전기 현황" text-color="title"/>
                      </div>
                      <div class="col-1 text-end">
                        <i class="mdi mdi-information-outline align-middle fs-4 pe-1" id="broken-info"
                           style="cursor:pointer; line-height: 14px"/>
                        <b-tooltip target="broken-info" placement="left">
                          <pre class="pre-tag-tooltip">고장 기준 : 충전기 상태 값인 에러코드가 OtherError인 상태로<br/>2시간 이상 지속 시 고장으로 정의</pre>
                        </b-tooltip>
                      </div>
                    </div>

                    <div class="row d-flex align-items-center h-100">
                      <div :class="!$_utils.isEmpty(brokenData.countByStopReason) ? 'col-5' : 'col'">
                        <apexchart height="237"
                                   :options="brokenPercentChartOptions" :series="brokenPercentChartSeries" />
                      </div>
                      <div class="col-7" v-if="!$_utils.isEmpty(brokenData.countByStopReason)">
                        <div class="ps-1 fw-bold">• 고장 발생 시 트랜잭션 상태 유형</div>
                        <div class="text-end text-secondary font-size-11 ">Total : {{ items.length }}</div>
                        <apexchart height="202"
                                   :options="brokenReasonChartOptions" :series="brokenReasonChartSeries" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3">
                <div class="card">
                  <div class="card-body">
                    <card-title icon-image="mdi-podium-gold" title="고장 발생건 순위" text-color="title"/>
                    <b-tabs active-nav-item-class="fw-bold" v-model="activeTab">
                      <template v-for="(tab, tabIdx) in rankingTabs">
                        <b-tab :key="tabIdx" :active="tabIdx === 0">
                          <template v-slot:title>
                            <span>{{ tab.title }}</span>
                          </template>
                          <div class="row">
                            <div class="col">
                              <div v-if="!$_utils.isEmpty(tab.content)" class="ranking-list">
                                <div v-for="(info, i) in tab.content" class="ranking-line rounded-pill">
                                  <div class="number-round rounded-circle">
                                    {{ i+1 }}
                                  </div>
                                  <div>
                                  <span v-if="tabIdx === 1">
                                    {{ info.userId }}
                                  </span>
                                    <span v-else>
                                    {{ info.csoEvseNum }}
                                  </span>
                                  </div>
                                  <div>
                                  <span v-if="tabIdx === 2">
                                    {{ info.totEnergy.toLocaleString(undefined, {maximumFractionDigits: 0}) }} kWh ({{ info.mon }}월)
                                  </span>
                                    <span v-else>
                                    {{ info.count }} 건
                                  </span>
                                  </div>
                                </div>
                              </div>
                              <div v-else class="empty-area" style="height: 200px;">
                                <span>조회기간의 데이터가 없습니다.</span>
                              </div>
                            </div>
                          </div>
                        </b-tab>
                      </template>
                    </b-tabs>
                  </div>
                </div>
              </div>

              <div class="col-xl-4">
                <div class="card">
                  <div class="card-body">
                    <div class="row">
                      <card-title icon-image="mdi-calendar-month" title="월별 고장 발생 추이" text-color="title" class="col-auto"/>
                      <div class="col text-end text-secondary">*최근 6개월</div>
                    </div>

                    <div class="row">
                      <div class="col-12">
                        <apexchart height="210"
                                   :options="monthlyBrokenCountChartOptions" :series="monthlyBrokenCountChartSeries" />
                      </div>
                      <div class="col-12 text-end mt-2">
                        <router-link :to="{
                        path: '/statistics-report',
                        query: { placeId: selectedStation.placeId, startDate: selectedDate[0], endDate: selectedDate[1]} }">
                          <i class='bx bx-link-external align-middle'/> 충전소 통계 확인하기
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <div class="card">
                  <div class="card-body">
                    <div class="row mb-2">
                      <div class="col-auto">
                        <card-title icon-image="mdi-table-large" title="고장 목록" text-color="title" style="margin-bottom: 0 !important;"/>
                      </div>
                      <div class="col pt-3 pe-3">
                        <div class="text-end align-items-end">
                          <span class="text-secondary">미복구 | </span>
                          <span class="fw-bold" style="color: #f5554a">{{ notRecoverd }}</span>
                          <span class="text-secondary ms-1">건</span>
                          <span class="text-secondary ms-3">전체 | </span>
                          <span class="fw-bold">{{ items.length }}</span>
                          <span class="text-secondary ms-1">건</span>
                        </div>
                      </div>
                    </div>

                    <div class="common-sticky-table border">
                      <b-table class="datatables text-nowrap text-center"
                               show-empty
                               responsive sticky-header="265px"
                               :tbody-tr-class = "rowClass"
                               :fields="fields" :items="items">
                        <template #cell(goneDay)="data">
                          {{ data.item.goneDay }}
                        </template>
                      </b-table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import SearchButtons from "@/views/components/searchButtons.vue";
import CardTitle from "@/views/components/cardTitle.vue";
import { http } from "@/mdk/auth-api";
import TotalCount from "@/views/components/totalCount.vue";

export default {
  name: "brokenCharger",
  components: { TotalCount, CardTitle, SearchButtons, Multiselect },
  data() {
    return {
      stationOptions: [],
      brokenData: {},
      selectedStation: {},
      selectedDate: [
        // moment().subtract(1, 'days').subtract(1, 'month').format('YYYY-MM-DD'),
        moment().date(1).format('YYYY-MM-DD'),
        moment().subtract(1, 'days').format('YYYY-MM-DD')
      ],
      brokenPercentChartSeries: [],
      brokenPercentChartOptions: {
        chart: {
          type: 'donut',
          toolbar: { show: false },
          selection: { enabled: false },
          fontFamily: 'NanumSquareRound',
        },
        legend: { show: false },
        colors: ['#f5554a', '#f4f4f4'],
        dataLabels: {
          enabled: true,
          enabledOnSeries: [0],
          formatter: (value, { seriesIndex, dataPointIndex, w }) => {
            const total = w.config.series.reduce((a, b) => a + b)
            return seriesIndex === 0 ? `${Math.round((w.config.series[0] / total) * 100)}%` : ''
          },
          textAnchor: 'middle',
          style: {
            fontSize: '12px',
            fontWeight: 400,
            colors: ['#ffffff'],
          },
          background: {
            enabled: true,
            padding: 5,
            foreColor: '#f5554a',
            borderRadius: 2,
            borderWidth: 1,
            borderColor: '#f5554a',
            opacity: 0.9,
          },
          dropShadow: {
            enabled: false,
          }
        },
        subtitle: {
          align: 'center',
          offsetY: 150,
          floating: true,
          style: {
            color:  '#858585',
          }
        },
        plotOptions: {
          pie: {
            expandOnClick: false,
            dataLabels: {
              minAngleToShowLabel: 1
            },
            donut: {
              size: '82%',
              labels: {
                show: true,
                name: {
                  show: true,
                  offsetY: -25,
                },
                value: {
                  show: true,
                  fontSize: '30px',
                  fontWeight: 400,
                  offsetY: -5,
                },
                total: {
                  show: true,
                  showAlways: true,
                  label: '고장',
                  fontSize: '15px',
                  fontWeight: 600,
                  color: '#f5554a',
                  formatter: w => `${w.globals.seriesTotals[0].toLocaleString()}기`
                }
              }
            }
          }
        },
        labels: ['고장', '정상'],
        stroke: {
          show: false,
        },
        tooltip: {
          enabled: true,
          fillSeriesColor: false,
          theme: 'light',
          y: {
            formatter: val => `${val.toLocaleString()} 기`,
          },
        },
        grid: {
          padding: {
            top: 20,
            right: 0,
            bottom: 20,
            left: 0
          },
        },
        states: {
          hover: {
            filter: {
              type: 'none',
            }
          },
          active: {
            filter: {
              type: 'none',
            }
          },
        },
        noData: {
          text: 'Loading...',
          offsetY: -20,
          style: {
            color: '#858585',
          }
        }
      },
      brokenReasonChartSeries: [],
      brokenReasonChartOptions : {
        chart: {
          type: 'bar',
          toolbar: { show: false },
          parentHeightOffset: 0,
          fontFamily: 'NanumSquareRound',
        },
        xaxis: {
          categories: [],
          tickAmount: 2,
        },
        yaxis: {
          tickAmount: 2,
          forceNiceScale: true,
          max: max => max < 5 ? 4 : Math.ceil(max / 10) * 10,
          labels: {
            formatter: val => val.toLocaleString()
          }
        },
        colors: ['#f5554a'],
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '20px',
          }
        },
        dataLabels: { enabled: false },
        legend: { show: false },
        tooltip: {
          x: { show: false },
          y: {
            formatter: val => `${val.toLocaleString()} 건`,
            title: {
              formatter: seriesName => '',
            },
          },
        },
        grid: {
          padding: {
            top: -30,
          },
        },
        states: {
          active: {
            filter: {
              type: 'none',
            }
          },
        },
        noData: {
          text: 'Loading...',
          offsetY: -20,
          offsetX: 30,
          style: {
            color: '#858585',
          }
        }
      },
      rankingTabs: [
        { title: '충전기', content: [] },
        { title: '이용자', content: [] },
        { title: '최근 충전량', content: [] }
      ],
      activeTab: 0,
      monthlyBrokenCountChartSeries: [],
      monthlyBrokenCountChartOptions: {
        chart: {
          type: 'bar',
          toolbar: { show: false },
          parentHeightOffset: 0,
          animations: {
            animateGradually: { enabled: false },
          },
        },
        colors: ['#006633ff'],
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '25px',
            endingShape: 'rounded'
          },
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          tickAmount: 2,
          max: max => max < 5 ? 4 : Math.ceil(max / 10) * 10,
          labels: {
            formatter: val => val.toLocaleString()
          }
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          x: { show: false },
          y: {
            formatter: val => `${val.toLocaleString()} 기`,
            title: {
              formatter: seriesName => '',
            },
          }
        },
        states: {
          active: {
            filter: {
              type: 'none',
            }
          },
        },
        noData: {
          text: 'Loading...',
          offsetY: -30,
          style: {
            color: '#858585',
          }
        },
      },
      fields: [
        { key: 'placeName', label: '충전소', sortable: true },
        { key: 'csoEvseNum', label: '충전기 ID', sortable: true },
        { key: 'created', label: '고장 발생 시간', sortable: true },
        { key: 'goneDay', label: '복구 대기 시간', sortable: true },
        { key: 'expiryTimestamp', label: '복구 완료 시간', sortable: true },
        { key: 'errorCode', label: '에러코드', sortable: true },
        { key: 'status', label: '고장 발생 시 상태', sortable: true },
        { key: 'stoppedReason', label: '트랜잭션 상태 유형', sortable: true },
        { key: 'userId', label: '사용자 ID', sortable: true }
      ],
      items: [],
      notRecoverd: 0
    }
  },
  created() {
    const vm = this;

    // 충전소 목록
    vm.getStationItems();
  },
  methods: {
    disabledAfterYesterday(date) {
      return date > moment().subtract(1, 'days');
    },
    async getStationItems() {
      const vm = this;
      const _url = `/onmapi/evse/faultSearchPlace`;

      try {
        const res = await http.get(_url);

        vm.stationOptions = [ ...res.data.items ];
        if (vm.stationOptions.length > 0) {
          vm.selectedStation = vm.stationOptions.find(ele => ele.placeId === 'all');
          vm.search();
        }

      } catch (err) {
        console.error(err);
      }
    },
    async getBrokenItems() {
      const vm = this;
      const _url = `/onmapi/evse/faultData`;

      try {
        const res = await http.get(_url, {
          params: {
            placeId: vm.selectedStation.placeId,
            startDate: vm.selectedDate[0],
            endDate: vm.selectedDate[1]
          }
        });

        vm.brokenData = res.data;
        vm.rankingTabs[0].content = vm.brokenData.topFiveByEvse;
        vm.rankingTabs[1].content = vm.brokenData.topFiveByUser;
        vm.rankingTabs[2].content = vm.brokenData.faultStatTopFive;
        vm.updateBrokenPercentChart();
        vm.updateBrokenReasonChart();
        vm.updateMonthlyChart();
        vm.updateBrokenTable();


      } catch (err) {
        console.error(err);
      }
    },
    updateBrokenPercentChart() {
      const vm = this;

      vm.brokenPercentChartSeries = [ vm.brokenData.chart[1].count, vm.brokenData.chart[2].count ];
      vm.brokenPercentChartOptions = {
        ...vm.brokenPercentChartOptions,
        ...{
          subtitle: {
            text: `전체 ${vm.brokenData.chart[0].count.toLocaleString()} 기`,
          }
        }
      };
    },
    updateBrokenReasonChart() {
      const vm = this;
      const categories = vm.brokenData.countByStopReason.map(ele => `${ele.stoppedReason}`);
      const series = vm.brokenData.countByStopReason.map(ele => `${ele.count}`);

      vm.brokenReasonChartSeries = [{ data: series }];
      vm.brokenReasonChartOptions = {
        ...vm.brokenReasonChartOptions,
        ...{
          xaxis: { categories: categories },
        }
      };
    },
    updateMonthlyChart() {
      const vm = this;
      const categories = vm.brokenData.countByMonth.map(ele => `${ele.mon}월`);
      const series = vm.brokenData.countByMonth.map(ele => ele.count);

      vm.monthlyBrokenCountChartSeries = [{ data: series }];
      vm.monthlyBrokenCountChartOptions = {
        ...vm.monthlyBrokenCountChartOptions,
        ...{
          xaxis: { categories: categories },
        }
      };
    },
    updateBrokenTable() {
      const vm = this;

      vm.items = vm.brokenData.items.map(ele => {
        return this.$_utils.isEmpty(ele.expiryTimestamp) ? { ...ele, status: 'broken' } : ele
      })
      vm.notRecoverd = vm.brokenData.items.filter(ele => this.$_utils.isEmpty(ele.expiryTimestamp)).length;
    },
    rowClass(item, type) {
      if (!item || type !== 'row') return
      if (item.status === 'broken') return 'broken-row'
    },
    search() {
      const vm = this;
      vm.getBrokenItems();
      vm.activeTab = 0;
    },
    // reset() {
    //   const vm = this;
    //
    //   vm.selectedStation = vm.stationOptions.find(ele => ele.placeId === 'all');
    //   vm.selectedDate = [
    //     // moment().subtract(1, 'days').subtract(1, 'month').format('YYYY-MM-DD'),
    //     moment().date(1).toDate(),
    //     moment().subtract(1, 'days').toDate()
    //   ]
    // },
  }
}
</script>